(function () {
  'use strict';

  /* @ngdoc object
   * @name crewPunctualityReport
   * @description
   *
   */
  angular
    .module('crewPunctualityReport', [
      'ui.router'
    ]);
}());
